import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaybankSnapInquiryComponent } from './maybank-snap-inquiry/maybank-snap-inquiry.component';
import { MaybankSnapPaymentComponent } from './maybank-snap-payment/maybank-snap-payment.component';
import { MaybankSnapPaymentResultComponent } from './maybank-snap-payment-result/maybank-snap-payment-result.component';
import {DirectiveModule} from '@shared/directive/directive.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedComponentModule} from '@shared/component/shared-component.module';



@NgModule({
  declarations: [MaybankSnapInquiryComponent, MaybankSnapPaymentComponent, MaybankSnapPaymentResultComponent],
    imports: [
        CommonModule,
        DirectiveModule,
        FormsModule,
        ReactiveFormsModule,
        SharedComponentModule
    ]
})
export class MaybankSnapModule { }
